import { useMutation, useQueryCache } from 'react-query';
import { CompetitionAPI } from 'api/admin/competition';
import { COMPETITIONS } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateCompetition() {
  const queryCache = useQueryCache();

  return useMutation(CompetitionAPI.updateCompetition, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(COMPETITIONS);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
